import type { LogtoConfig } from "@logto/react";

export const authConfig: LogtoConfig = {
  endpoint: "https://auth.everbay.de/",
  appId: "lnMAq3onT83h93P94AiLm",
  resources: ["https://api.gowoop.de", "https://backend.gowoop.de"],
  scopes: [
    // Without this scope Logto ties the refresh token to the sign-in session
    // (1 day). The app's refresh-token TTL is 7 days and only applies when
    // the token is not session-bound.
    "offline_access",
    "email",
    "custom_data",
    "read:user",
    "write:user",
    "update:user",
    "delete:user",
  ],
};
